import { getNewTokens } from '../actions/helperAction';

let buffer = [];

// eslint-disable-next-line consistent-return
export const jwt = (store) => (next) => (action) => {
  buffer.push(action);
  if (action.type === 'INVALID_TOKEN') {
    const theStore = store.getState();
    if (theStore.currentUser && theStore.currentUser.token) {
      if (!theStore.currentUser.token.refreshing) {
        store.dispatch({ type: 'REFRESHING_TOKEN' });
        store.dispatch(getNewTokens()).then(() => {
          store.dispatch({ type: 'REFRESHING_TOKEN_DONE' });
          const pos = buffer.map((e) => e.type).indexOf('INVALID_TOKEN') - 1;
          for (let i = pos; i <= buffer.length; i += 1) {
            if (typeof buffer[i] === 'function') {
              store.dispatch({
                type: 'RESEND',
                action: buffer[i](store.dispatch, store.getState),
              });
            }
          }
          buffer = [];
        });
      }
    }
  } else if (action.type === 'RESET_ALL') {
    buffer = [];
  } else {
    if (buffer.length > 40) {
      buffer.splice(0, buffer.length - 40);
    }
    return next(action);
  }
};
